import { Model } from '@/models/Model';
export class Skill extends Model {
    constructor() {
        super(...arguments);
        this.$name = 'Skill';
        this.$endpoint = '/skills';
        this.$fillable = [];
    }
}
export var SkillIncludes;
(function (SkillIncludes) {
    SkillIncludes["CATEGORY"] = "category";
})(SkillIncludes || (SkillIncludes = {}));
